import { Box, Typography } from "@mui/material";
import React from "react";
import AdminIcon from "../../assets/SVG/adminIcon";
import HospitalIcon from "../../assets/SVG/hospitalIcon";
import MedicalIcon from "../../assets/SVG/medicalIcon";
import UniversityIcon from "../../assets/SVG/universityIcon";

export default function SidebarSignin({setLevel,level}) {
  return (
    <>
      <Box
        sx={{ cursor: "pointer", width: "200px",transition:'1s all' }}
        display="flex"
        alignItems="center"
        my='20px'
        // onClick={()=>{  setLevel(1)}}
        >
        <AdminIcon color={level===1?"white":"var(--emr-darkblue)"} />
        <Typography color={level===1?"white":"var(--emr-darkblue)"}  mr="10px" sx={{transition:'0.3s all'}}  fontSize="19px">
          {"اطلاعات مسئول"}
        </Typography>
      </Box>
      <Box
        my='20px'
        sx={{ cursor: "pointer", width: "200px",transition:'1s all' }}
        display="flex"
        alignItems="center"
        onClick={()=>{if(level>1) setLevel(2)}}
        >
        <UniversityIcon color={level===2?"white":"var(--emr-darkblue)"} />
        <Typography color={level===2?"white":"var(--emr-darkblue)"} mr="10px" sx={{transition:'0.3s all'}}  fontSize="19px">
          {"مشخصات گروه"}
        </Typography>
      </Box>
      <Box
          my='20px'
          sx={{ cursor: "pointer", width: "200px",transition:'1s all' }}
          display="flex"
          alignItems="center"
          onClick={()=>{if(level>2) setLevel(3)}}
          >
        <MedicalIcon color={level===3?"white":"var(--emr-darkblue)"} />
        <Typography color={level===3?"white":"var(--emr-darkblue)"} mr="10px" sx={{transition:'0.3s all'}}  fontSize="19px">
          {"تجهیزات گروه"}
        </Typography>
      </Box>
      <Box
        my='20px'
        sx={{ cursor: "pointer", width: "200px",transition:'1s all' }}
        display="flex"
        alignItems="center"
        onClick={()=>{if(level>3) setLevel(4)}}
      >
        <HospitalIcon color={level===4?"white":"var(--emr-darkblue)"} />
        <Typography color={level===4?"white":"var(--emr-darkblue)"} mr="10px" sx={{transition:'0.3s all'}}  fontSize="19px">
          {"بخش‌ها"}
        </Typography>
      </Box>
    </>
  );
}
